type Func<A extends unknown[], R> = (...args: A) => R;
export type TagFunc<A extends unknown[], R> = R | Func<A, R>;
export function tagCall<A extends unknown[], R>(tagFunc: TagFunc<A, R>, ...args: A) {
  if (typeof tagFunc === 'function') {
    return (tagFunc as Func<A, R>)(...args);
  } else {
    return tagFunc;
  }
}
